import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="section-inner footer-inner">
        <span className="footer-text mono">© 2026 John Paulo Guimalan</span>
        <span className="footer-text mono">Designed &amp; built from scratch</span>
        <a className="lnk footer-link mono" href="#top">
          Back to top ↑
        </a>
      </div>
    </footer>
  );
}
